module.exports = __webpack_public_path__ + "static/media/checked.da188ccb.png";